import { moment } from "components/tdc-core/utils/commonUtils"
import str from "../utils/strings"

export function formatLocalizedDollar(dollar, currency) {
  let dollarString = formatDollar(dollar) || ""
  switch (currency) {
    case "HKD":
      dollarString = `${str.TXT_APP_Currency_HKD} ${dollarString}`
      break
    case "RMB":
      dollarString = `${str.TXT_APP_Currency_RMB} ${dollarString}`
      break
    case "USD":
      dollarString = `${str.TXT_APP_Currency_USD} ${dollarString}`
      break
  }
  return dollarString
}

export const dateFormat = {
  dateOnly: "DD MMM YYYY",
  hkTimeZone: "YYYY-MM-DDT00:00:00+08:00"
}

export function formatDateOnly(timestamp) {
  return timestamp ? moment(timestamp).format(dateFormat.dateOnly) : null
}

export function formatHKTimeZone(timestamp) {
  return timestamp ? moment(timestamp).format(dateFormat.hkTimeZone) : null
}

export function formatDollar(dollar) {
  if (typeof dollar !== "number") return
  const roundedDollar = Math.floor(dollar)
  return `${roundedDollar.toLocaleString([], {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  })}`
}
